import React from 'react';
import { Grid, Typography } from '@mui/material';
import CalendarNext from 'components/svg/nextCalendarButton.svg';
import CalendarPrev from 'components/svg/prevCalendarButton.svg';
import IconButton from 'components/common/IconButton';
import Button from 'components/common/Button';
import { useTranslation } from 'i18n';

interface CalendarHeaderProps {
  currentMonthLabel: string;
  onPrevMonth: () => void;
  onNextMonth: () => void;
  onTodayClick: () => void;
}

const CalendarHeader: React.FC<CalendarHeaderProps> = ({
  currentMonthLabel,
  onPrevMonth,
  onNextMonth,
  onTodayClick,
}) => {
  const [t] = useTranslation('public');

  return (
    <Grid container justifyContent="flex-end" alignItems="center" spacing={0.5}>
      <Grid item>
        <Typography variant="h6" fontWeight={500}>
          {currentMonthLabel}
        </Typography>
      </Grid>

      <Grid item>
        <Grid container wrap="nowrap" alignItems="center" spacing={0.5}>
          <Grid item>
            <IconButton color="primary" onClick={onPrevMonth}>
              <CalendarPrev />
            </IconButton>
          </Grid>

          <Grid item>
            <Button
              variant="outlined"
              rounded
              size="small"
              onClick={onTodayClick}
              sx={{ textTransform: 'none', whiteSpace: 'nowrap' }}
            >
              {t('calendar.today')}
            </Button>
          </Grid>

          <Grid item>
            <IconButton onClick={onNextMonth}>
              <CalendarNext />
            </IconButton>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default CalendarHeader;
